export const table = {
  baseStyle: {
    caption: {
      fontFamily: "heading",
      fontWeight: "medium",
      mt: 4,
      textAlign: "center"
    },
    table: {
      borderCollapse: "collapse",
      fontVariantNumeric: "lining-nums tabular-nums",
      width: "full",
      margin: 4
    },
    td: {
      textAlign: "start",
      fontFamily: "heading",
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 30,
      color: "#000000",
      border: "none",
      padding: "none"
    },
    tr: {
      _hover: {
        background: "rgba(207, 207, 207, 1)",
        borderRadius: "md"
      },
      borderRadius: 16,
      border: "none",
      padding: 2
    },
    th: {
      fontFamily: "heading",
      fontWeight: 400,
      fontSize: 16,
      color: "#999999",
      letterSpacing: "wider",
      textAlign: "start",
      textTransform: "Capitalize",
      border: "none",
      _hover: {
        background: "transparent"
      }
    }
  },

  parts: {
    8: "title"
  },

  variants: {
    evt: {
      table: {
        length: 2
      }
    }
  },

  defaultProps: {}
}
